import React, { useContext, useEffect, useState } from "react";
import {
  FieldButtonGroup,
  FieldInputDollarBox,
  FieldInputPercentageBox,
  FormControlSearch,
  LoaderWrapper,
  ManageFeeLayout,
  SliderPanel,
  AddToolTip,
} from "../../../components";
import { Button, Form, InputGroup } from "react-bootstrap";
import {
  FEE_TYPE_MAPPING,
  FLOW_TYPES,
  MANAGE_FEE_ROUTES,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  clearFieldValues,
  formFields,
  manageFeeFormNames,
  toOptionValuesFromMapper,
  yesNoOptions,
  getPathWithParam,
  synchronizeCollectionNew,
  getAdvancedPathWithParam,
} from "../../../utils";
import { flow, get, isEmpty } from "lodash";
import { Field, Formik } from "formik";
import {
  ManageFeeProvider,
  manageFeeStore,
  setFeeIdInfo,
  setFeeIsLoading,
  setManageCalculationData,
  setBasicFeeData,
  setManageFeeData,
  setManageFeeFlow,
  setFeeCalculationData,
} from "../../../contexts";
import {
  SaveFeeCalculationDetails,
  ValidateCreateSpecificationSlider,
  getFeeDetailsById,
  getFeeCalculationDetailsById,
} from "../../../services";
import { useRequest, useRouterParams } from "../../../abstracts";
import AddSpecificationSlider from "../ManageSpecificationContainer/AddSpecificationSlider";
import InvestmentSlider from "./InvestmentSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faFileEdit, faTimes } from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../../abstracts";
import {
  getFeeSpecificationBasedOnSearchCriteria,
  getInvestmentType,
  getMasterInvestmentBySearchCriteria,
  saveInvestment,
} from "../../../services";
import TieredParticiantBalance from "./TieredParticipantBalance";
import CreateSpecificationSlider from "./CreateSpecificationSlider";
import { useHistory } from "react-router-dom";
import ValidationPopup from "./ValidationPopup";
import { getInvestment } from "../../../services/trade";
const InvestmentCard = ({
  setInvestmentSlider,
  isEdit,
  isSave,
  values,
  fields,
  setInvestmentSelected,
  apiData,
}) => {
  const [investment, setInvestment] = useState({});
  useDeepEffect(() => {
    getInvestment(values[fields.investmentId])
      .then((res) => {
        setInvestment(res);
      })
      .catch((err) => {});
  }, [values[fields.investmentId]]);

  return (
    <div className="investmentCard">
      <p className="fw-600 ft-16 ml-4 mt-3" style={{ color: "#7C7C80" }}>
        Investment Added
      </p>
      <div className="fw-600 ft-16 ml-4 d-flex" style={{ color: "#242426" }}>
        <div
          style={{
            textOverflow: "ellipsis",
            maxWidth: "80%",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {investment?.name}
        </div>
        <span
          style={{
            marginLeft: "auto",
            marginRight: "2rem",
            cursor: apiData.step >= 5 ? "not-allowed" : "default",
          }}
        >
          <FontAwesomeIcon
            className="primary-small"
            icon={faEdit}
            onClick={() => {
              apiData.step < 5 && setInvestmentSlider(true);
              apiData.step < 5 &&
                setInvestmentSelected(values[fields.investmentId]);
            }}
          />
        </span>
      </div>
      <p className="fw-500 ft-14 ml-4" style={{ color: "#444446" }}>
        {investment?.cusip == null ? "-" : investment?.cusip}
      </p>
    </div>
  );
};
const CalculateContainer = (props) => {
  const history = useHistory();

  const data = [
    {
      Name: "$ 1000 Plan",
      Description:
        "$ 1000 pro - rate across all participants fixed amount payroll processing fee",
      AllocationType: "Fixed Amount",
    },
    {
      Name: "$ 4500 Plan",
      Description: "$ 5 if balance between 5000 to 10000",
      AllocationType: "Tiered",
    },
    {
      Name: "$ 5480 Plan",
      Description: "-",
      AllocationType: "Percentage",
    },
    {
      Name: "$ 6540 Plan",
      Description: "$ 2000 pro - rate across all participants",
      AllocationType: "Fixed Amount",
    },
    {
      Name: "$ 170000 Plan",
      Description: "$ 2000 pro - rate across all participants",
      FeeType: "Investment based",
      AllocationType: "Tiered",
    },
  ];
  const formName = manageFeeFormNames.CALCULATION;

  const fields = formFields[formName];
  const { state, dispatch } = useContext(manageFeeStore);
  const [apiData, setApiData] = useState([]);
  const { calculationId, flow, feeId } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const [sliderOpen, setSliderOpen] = useState(false);
  const [investmentSlider, setInvestmentSlider] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [calculationDetails, setCalculationDetails] = useState([]);
  const [showErr, setShowErr] = useState(false);
  const [investmentErrorMessage, setShowInvestmentErrorMessage] = useState(
    false
  );

  const [investmentSelected, setInvestmentSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [investmentType, setInvestmentTypes] = useState([]);
  const [saveInvestment, setSaveInvestment] = useState();
  const [addSpecificationdata, setAddSpecificationData] = useState(
    [apiData.feeSpecification] || []
  );
  const [
    createSpecificationSliderOpen,
    setCreateSpecificationSliderOpen,
  ] = useState(false);
  const [showValidationPopup, setShowValidationPopup] = useState(false);

  //use calculation api instead of feeBasicDetails api. for loading purpose we usedfeeBasicDetails api.

  useEffect(() => {
    if (feeId && isEmpty(apiData)) {
      dispatch(setFeeIsLoading(true));
      getFeeCalculationDetailsById(feeId).then((res) => {
        if (res.isSuccessfull) {
          dispatch(setManageCalculationData(res));
          setApiData(res.calculationDetails);
          setAddSpecificationData([res?.calculationDetails?.feeSpecification]);
          dispatch(
            setFeeIdInfo({
              id: res.calculationDetails.id,
              step: res.calculationDetails.step,
            })
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    getInvestmentType()
      .then((response) => {
        setLoading(false);
        setInvestmentTypes([...investmentType, ...response]);
      })
      .catch((ex) => {
        setLoading(false);
      });
  }, []);

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    setSubmitting(true);
    SaveFeeCalculationDetails(
      {
        ...values,
        [fields.feeSpecification]: {
          ...values[fields.feeSpecification],
          feeTiers: synchronizeCollectionNew(
            addSpecificationdata?.feeTiers ?? [],
            get(values, `${fields.feeSpecification}.${fields.feeTiers}`) ?? [],
            "id"
          ),
        },
        id: parseInt(feeId),
      },
      dispatch,

      state
    )
      .then((response) => {
        setIsLoading(false);
        dispatch(setManageCalculationData(response));
        dispatch(
          setFeeIdInfo({
            id: response.calculationDetails.id,
            step: response.calculationDetails.step,
          })
        );
        if (!response.isSuccessful) {
          setShowValidationPopup(false);
          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
          apiData.step = response?.calculationDetails.step;
        } else {
          setShowValidationPopup(false);
          dispatch(setManageFeeFlow({}));
          dispatch(setFeeCalculationData(response));
          dispatch(
            setFeeIdInfo({
              id: response?.calculationDetails.id,
              step: response?.calculationDetails.step,
            })
          );
          setApiData(response.calculationDetails);
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_FEE_ROUTES.APPLICABLE_TO,
              pathParam:
                response?.calculationDetails.step >= 5
                  ? [FLOW_TYPES.SAVE, response?.calculationDetails?.id]
                  : [response?.calculationDetails?.id],
            })
          );
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleCancelClick = () => {
    setShowValidationPopup(false);
  };

  const initialValues = {};
  return (
    <LoaderWrapper isLoading={false}>
      <Formik
        onSubmit={onFormSubmit}
        initialValues={{
          ...initialValues,
          feeType: get(apiData, "feeType"),
          processMinAmount: get(apiData, "processMinAmount"),
          percentageOfAccountBalanceAvailable: get(
            apiData,
            "percentageOfAccountBalanceAvailable"
          ),
          excludeFullyPaidOutParticipants: get(
            apiData,
            "excludeFullyPaidOutParticipants"
          ),
          runFeeFor:
            get(apiData, "runFeeFor") !== null ? get(apiData, "runFeeFor") : 1,
          includeLoanBalancesInAssetComputation: get(
            apiData,
            "includeLoanBalancesInAssetComputation"
          ),
          feeSpecificationId: get(apiData, "feeSpecificationId"),
          feeToBeCollectedFromOnlySelectedInvestment: get(
            apiData,
            "feeToBeCollectedFromOnlySelectedInvestment"
          ),
          minimumThresholdBalance: get(apiData, "minimumThresholdBalance"),
          investmentId: get(apiData, "investmentId"),
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          setFieldError,
          setTouched,
          setFieldTouched,
          handleSubmit,
          errors,
          values,
          setSubmitting,
          ...rest
        }) => {
          const buttons = [
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              link: ROUTES.FEE,
              flow: [FLOW_TYPES.ADD],
            },
            {
              label: "Next",
              variant: "primary",
              flow: [FLOW_TYPES.ADD],
              type: "button",
              onClick: () => {
                if (
                  (apiData.feeType !== null &&
                    apiData.feeType !== values[fields.feeType]) ||
                  (apiData.investmentId !== null &&
                    apiData.investmentId !== values[fields.investmentId]) ||
                  (apiData.feeToBeCollectedFromOnlySelectedInvestment !==
                    null &&
                    apiData.feeToBeCollectedFromOnlySelectedInvestment !==
                      values[fields.feeToBeCollectedFromOnlySelectedInvestment])
                )
                  setShowValidationPopup(true);
                else {
                  onFormSubmit(values, {
                    setFieldError,
                    setFieldTouched,
                    setSubmitting,
                  });
                }
              },
            },
          ];

          const editbuttons = [
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              flow: [FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
              link: ROUTES.FEE,
            },
            {
              label: "Next",
              variant: "primary",
              type: "button",
              flow: [FLOW_TYPES.EDIT],
              onClick: () =>
                history.push(
                  getAdvancedPathWithParam({
                    path: MANAGE_FEE_ROUTES.APPLICABLE_TO,
                    pathParam: [FLOW_TYPES.EDIT, feeId],
                  })
                ),
            },
            {
              label: "Save & Proceed",
              variant: "primary",
              type: "submit",
              flow: [FLOW_TYPES.SAVE],
            },
          ];

          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          const onSaveSliderData = () => {
            if (!values.feeSpecificationId) {
              setShowErrorMessage(true);
            } else {
              setSliderOpen(false);
              setShowErrorMessage(false);
            }
          };

          const onFeeTypeChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
                fieldsToClear: [
                  fields.feeType,
                  fields.investmentId,
                  fields.feeSpecificationId,
                  fields.feeSpecification,
                  fields.feeToBeCollectedFromOnlySelectedInvestment,
                  fields.includeLoanBalancesInAssetComputation,
                ],
              }),
              [fields.feeType]: value,
            });
          };
          const onRunForFeeChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
                fieldsToClear: [fields.runFeeFor],
              }),
              [fields.runFeeFor]: value,
            });
          };

          const onProcessMinAmountChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
              }),
              [fields.processMinAmount]: value === false ? false : true,
            });
          };

          const onExcludeFullyPaidForFeesChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
              }),
              [fields.excludeFullyPaidOutParticipants]:
                value === false ? false : true,
            });
          };
          const onIncludeLoanBalancesInAssetComputationsChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
              }),
              [fields.includeLoanBalancesInAssetComputation]:
                value === false ? false : true,
            });
          };
          const saveInvestmentSlider = () => {
            if (!investmentSelected) {
              setShowInvestmentErrorMessage(true);
            } else {
              setFieldValue(fields.investmentId, investmentSelected);
              setInvestmentSlider(false);
              setShowInvestmentErrorMessage(false);
            }
          };
          const onFeeToBeCollectedOnlyFromThisInvestmentChange = (value) => {
            setValues({
              ...clearFieldValues({
                values,
              }),
              [fields.feeToBeCollectedFromOnlySelectedInvestment]:
                value === false ? false : true,
            });
          };

          const specificationSelected = values.feeSpecificationId
            ? addSpecificationdata?.find(
                (item, index) => item?.id == values.feeSpecificationId
              )
            : values[fields.feeSpecification];

          const handleConfirmClick = () => {
            onFormSubmit(values, {
              setFieldError,
              setFieldTouched,
              setSubmitting,
            });
          };

          return (
            <Form
              autoComplete="off"
              className="calculation-container-fee h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <ManageFeeLayout
                isCreateFee={true}
                buttons={apiData.step >= 5 ? editbuttons : buttons}
                pageFlow={flow}
              >
                <Field
                  isRequired
                  name={fields.feeType}
                  label={"Fee type"}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.CALCULATIONFEE_TYPE
                  )}
                  selectedValue={values[fields.feeType]}
                  value={values[fields.feeType]}
                  onChange={onFeeTypeChange}
                  component={FieldButtonGroup}
                  disabled={apiData.step >= 5}
                  size="smd"
                />

                {values[fields.feeType] === FEE_TYPE_MAPPING.InvestmentBased &&
                values[fields.feeType] !== FEE_TYPE_MAPPING.BalanceBased &&
                !values[fields.investmentId] ? (
                  <div
                    style={{
                      height: "150px",
                      width: "1000px",
                      borderRadius: "5px",
                      border: "1px solid #E5E5E5",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div
                        style={{
                          marginTop: "40px",
                          marginLeft: "20px",
                          fontSize: "16px",
                        }}
                      >
                        <b> No Investment added</b> <br />
                        <div style={{ marginTop: "10px" }}>
                          <Button
                            style={{
                              marginRight: "10px",
                              borderRadius: "8px",
                            }}
                            variant="secondary"
                            onClick={() => {
                              setInvestmentSlider(true);
                              setInvestmentSelected(
                                values[fields.investmentId]
                              );
                            }}
                          >
                            Add Investment
                          </Button>
                          <div className="invalid-feedback-error">
                            {get(errors, "investment", "")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {values[fields.feeType] !== FEE_TYPE_MAPPING.BalanceBased &&
                  values[fields.investmentId] && (
                    <InvestmentCard
                      setInvestmentSlider={setInvestmentSlider}
                      isEdit={isEdit}
                      isSave={isSave}
                      values={values}
                      fields={fields}
                      setInvestmentSelected={setInvestmentSelected}
                      apiData={apiData}
                    />
                  )}

                {values[fields.feeType] &&
                  values[fields.feeType] !== FEE_TYPE_MAPPING.BalanceBased && (
                    <Field
                      size="sm"
                      isRequired
                      name={fields.feeToBeCollectedFromOnlySelectedInvestment}
                      label={"Fee to be collected only from this investment"}
                      options={yesNoOptions}
                      selectedValue={
                        values[
                          fields.feeToBeCollectedFromOnlySelectedInvestment
                        ]
                      }
                      value={
                        values[
                          fields.feeToBeCollectedFromOnlySelectedInvestment
                        ]
                      }
                      onChange={onFeeToBeCollectedOnlyFromThisInvestmentChange}
                      disabled={apiData.step >= 5}
                      component={FieldButtonGroup}
                    />
                  )}

                <Field
                  size="sm"
                  isRequired
                  name={fields.processMinAmount}
                  label={"Process Minimum Amount"}
                  options={yesNoOptions}
                  selectedValue={values[fields.processMinAmount]}
                  value={values[fields.processMinAmount]}
                  onChange={onProcessMinAmountChange}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                <Field
                  size="sm"
                  isRequired
                  style={{ marginBottom: "0px" }}
                  name={fields.minimumThresholdBalance}
                  label="Minimum Threshold – Participant Balance"
                  type="text"
                  autoComplete="off"
                  disabled={isEdit && !isSave}
                  value={get(values, fields.minimumThresholdBalance)}
                  onChange={handleChange}
                  component={FieldInputDollarBox}
                />
                <Field
                  size="xs"
                  isRequired
                  name={fields.percentageOfAccountBalanceAvailable}
                  label="Percentage of Account balance considered for Fee Deduction"
                  type="number"
                  autoComplete="off"
                  value={values[fields.percentageOfAccountBalanceAvailable]}
                  onChange={handleChange}
                  component={FieldInputPercentageBox}
                  disabled={isEdit && !isSave}
                />
                <Field
                  size="sm"
                  isRequired
                  name={fields.excludeFullyPaidOutParticipants}
                  label={
                    "Exclude fully paid out participants from fee computation"
                  }
                  options={yesNoOptions}
                  selectedValue={values[fields.excludeFullyPaidOutParticipants]}
                  value={values[fields.excludeFullyPaidOutParticipants]}
                  onChange={onExcludeFullyPaidForFeesChange}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                <Field
                  isRequired
                  name={fields.runFeeFor}
                  label={"Run fee for"}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.RUNFEE_FOR
                  )}
                  selectedValue={values[fields.runFeeFor]}
                  value={values[fields.runFeeFor]}
                  onChange={onRunForFeeChange}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                  size="smd"
                />
                {(values[fields.feeType] == null ||
                  values[fields.feeType] == FEE_TYPE_MAPPING.BalanceBased) && (
                  <Field
                    size="sm"
                    isRequired
                    name={fields.includeLoanBalancesInAssetComputation}
                    label={
                      "Include Loan Outstanding Principal in asset computation"
                    }
                    options={yesNoOptions}
                    selectedValue={
                      values[fields.includeLoanBalancesInAssetComputation]
                    }
                    value={values[fields.includeLoanBalancesInAssetComputation]}
                    onChange={onIncludeLoanBalancesInAssetComputationsChange}
                    component={FieldButtonGroup}
                    disabled={isEdit && !isSave}
                  />
                )}

                {!values.feeSpecificationId &&
                isEmpty(values[fields.feeSpecification]) &&
                (values[fields.feeType] === FEE_TYPE_MAPPING.InvestmentBased ||
                  values[fields.feeType] === FEE_TYPE_MAPPING.BalanceBased) ? (
                  <div>
                    <b>Fee Specification</b>
                    <div
                      style={{
                        height: "150px",
                        width: "1000px",
                        borderRadius: "5px",
                        border: "1px solid #E5E5E5",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-baseline">
                        <div
                          style={{
                            marginTop: "40px",
                            marginLeft: "20px",
                            fontSize: "16px",
                            color: "#363638",
                          }}
                        >
                          <b> No fee specification is added</b> <br />
                          <div className="d-flex">
                            <div style={{ marginTop: "10px" }}>
                              <Button
                                style={{
                                  marginRight: "10px",
                                  borderRadius: "8px",
                                }}
                                variant="secondary"
                                onClick={() => {
                                  setSliderOpen(true);
                                  setFieldValue(fields.allocationType, null);
                                }}
                              >
                                Add Existing Specification
                              </Button>
                            </div>
                            <div className="h-100 align-self-center">or</div>
                            <b style={{ marginLeft: "15px" }} />
                            <Button
                              style={{
                                marginRight: "10px",
                                borderRadius: "8px",
                              }}
                              variant="secondary"
                              onClick={() => {
                                setCreateSpecificationSliderOpen(true);
                                setShowErr(false);
                              }}
                            >
                              Create Specification
                            </Button>{" "}
                          </div>
                          <div className="error-message-spec">
                            {errors?.specificationOption ?? ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <CreateSpecificationSlider
                  feeType={values[fields.feeType]}
                  showErr={showErr}
                  setShowErr={setShowErr}
                  initialValues={values[fields.feeSpecification]}
                  setOuterFieldValue={setFieldValue}
                  createSpecificationSliderOpen={createSpecificationSliderOpen}
                  setCreateSpecificationSliderOpen={
                    setCreateSpecificationSliderOpen
                  }
                />
                <SliderPanel
                  isOpen={investmentSlider}
                  size="48"
                  showHeader={true}
                  showCancel={false}
                  showCancelButton={true}
                  showSave={true}
                  onSave={() => saveInvestmentSlider()}
                  onClose={() => {
                    setInvestmentSlider(false);
                    setShowInvestmentErrorMessage(false);
                  }}
                  backdropClicked={() => {
                    setInvestmentSlider(false);
                    setShowInvestmentErrorMessage(false);
                  }}
                >
                  <InvestmentSlider
                    investmentErrorMessage={investmentErrorMessage}
                    setShowInvestmentErrorMessage={setShowErrorMessage}
                    investmentType={investmentType}
                    setInvestmentTypes={setInvestmentTypes}
                    fields={fields}
                    values={values}
                    setFieldValue={setFieldValue}
                    saveInvestment={saveInvestment}
                    setSaveInvestment={setSaveInvestment}
                    setInvestmentSelected={setInvestmentSelected}
                    investmentSelected={investmentSelected}
                  />
                </SliderPanel>

                <SliderPanel
                  isOpen={sliderOpen}
                  size="65"
                  showHeader={true}
                  showCancel={true}
                  showSave={true}
                  onSave={() => onSaveSliderData()}
                  onClose={() => {
                    setSliderOpen(false);
                    setFieldValue(fields.allocationType, null);
                    setShowErrorMessage(false);
                    setFieldValue(fields.feeSpecificationId, null);
                  }}
                  backdropClicked={() => {
                    setSliderOpen(false);
                    setShowErrorMessage(false);
                  }}
                >
                  <AddSpecificationSlider
                    showErrorMessage={showErrorMessage}
                    setShowErrorMessage={setShowErrorMessage}
                    addSpecificationdata={addSpecificationdata}
                    setAddSpecificationData={setAddSpecificationData}
                    fields={fields}
                    setLoading={setLoading}
                    loading={loading}
                  />
                </SliderPanel>

                {!isEmpty(specificationSelected) ? (
                  <>
                    <div className="tieredParticipantCard">
                      <div className="d-flex">
                        <div className="ml-3 mt-3 ft-16 fw-600">
                          Specification Information
                        </div>
                        <div className="d-flex ml-auto">
                          {!isEmpty(values[fields.feeSpecification]) && (
                            <div
                              className="d-flex align-items-center mr-4 removeIcon"
                              onClick={() => {
                                setCreateSpecificationSliderOpen(true);
                              }}
                            >
                              <FontAwesomeIcon
                                className="removeIcon mr-2"
                                icon={faEdit}
                                onClick={() => setShowErr(false)}
                              />
                              Edit
                            </div>
                          )}
                          <div
                            className="d-flex align-items-center mr-4"
                            onClick={() => {
                              !isEdit &&
                                setFieldValue(fields.feeSpecification, {});
                              !isEdit &&
                                setFieldValue(fields.feeSpecificationId, null);
                              !isEdit && setAddSpecificationData([]);
                            }}
                          >
                            <FontAwesomeIcon
                              style={{
                                cursor: isEdit ? "not-allowed" : "pointer",
                              }}
                              className="removeIcon mr-2"
                              icon={faTimes}
                            />
                            <span
                              style={{
                                cursor: isEdit ? "not-allowed" : "pointer",
                              }}
                              className="fw-600 ft-16 removeText"
                            >
                              Remove
                            </span>
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{ marginLeft: "20px", marginRight: "20px" }}
                      ></hr>

                      <p className="ml-3 mt-3 ft-14 fw-200 grey">
                        Specification name
                        {specificationSelected?.name !== null ? (
                          <p className="mt-1 ft-14 fw-600 black">
                            {specificationSelected?.name}
                          </p>
                        ) : (
                          <div>{"-"}</div>
                        )}
                      </p>

                      <p className="ml-3 mt-3 ft-14 fw-200 grey">
                        Specification description
                        {"description" in specificationSelected ? (
                          <p className="mt-1 ft-14 fw-600 black">
                            {specificationSelected?.description?.length <=
                            70 ? (
                              specificationSelected?.description
                            ) : (
                              <AddToolTip
                                className="fw-600 ft-16 valueDetails"
                                name={specificationSelected?.description}
                              >
                                {specificationSelected?.description?.slice(
                                  0,
                                  70
                                )}
                                ...
                              </AddToolTip>
                            )}
                          </p>
                        ) : (
                          <p>{"-"}</p>
                        )}
                      </p>

                      <p className="ml-3 mt-3 ft-14 fw-200 grey">
                        Fee Type
                        {specificationSelected.feeType == 1 ? (
                          <p className="mt-1 ft-14 fw-600 black">
                            {"Balance Based"}
                          </p>
                        ) : (
                          <p className="mt-1 ft-14 fw-600 black">
                            {"Investment Based"}
                          </p>
                        )}
                      </p>

                      <p className="ml-3 mt-3 ft-14 fw-200 grey">
                        Allocation Type
                        {specificationSelected.allocationType == 1 ? (
                          <p className="mt-1 ft-14 fw-600 black">
                            {"Fixed Amount"}
                          </p>
                        ) : specificationSelected.allocationType == 2 ? (
                          <p className="mt-1 ft-14 fw-600 black">
                            {"Percentage/Basis Points"}
                          </p>
                        ) : (
                          <p className="mt-1 ft-14 fw-600 black">{"Tiered"}</p>
                        )}
                      </p>

                      {specificationSelected.allocationType == 3 && (
                        <p className="ml-3 mt-3 ft-14 fw-200 grey">
                          Tier Computation type
                          {specificationSelected?.tierComputationType == 1 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Step Rate"}
                            </p>
                          ) : (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Exclusive"}
                            </p>
                          )}
                        </p>
                      )}

                      {specificationSelected.allocationType == 3 && (
                        <p className="ml-3 mt-3 ft-14 fw-200 grey">
                          Tier Computation Subtype
                          {specificationSelected?.tierComputationSubType ==
                          1 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Fixed Amount"}
                            </p>
                          ) : (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Percentage / Basis Points"}
                            </p>
                          )}
                        </p>
                      )}

                      <p className="ml-3 mt-3 ft-14 fw-200 grey">
                        Allocation sub-type
                        <p className="mt-1 ft-14 fw-600 black">
                          {specificationSelected?.allocationSubType == 1 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Participant balance"}
                            </p>
                          ) : specificationSelected?.allocationSubType == 2 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Plan balance"}
                            </p>
                          ) : (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Investment Based"}
                            </p>
                          )}
                        </p>
                      </p>

                      {specificationSelected.allocationSubType == 2 && (
                        <p className="ml-3 mt-3 ft-14 fw-200 grey">
                          Participant Allocation
                          {specificationSelected?.participantAllocation == 1 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Prorated"}
                            </p>
                          ) : (
                            <p className="mt-1 ft-14 fw-600 black">{"Equal"}</p>
                          )}
                        </p>
                      )}

                      {specificationSelected.allocationType == 1 && (
                        <p className="ml-3 mt-3 ft-14 fw-200 grey">
                          Fee Amount
                          <p className="mt-1 ft-14 fw-600 black">
                            $ {specificationSelected?.feeAmount}
                          </p>
                        </p>
                      )}

                      {(specificationSelected.allocationType == 2 ||
                        (specificationSelected.allocationType == 3 &&
                          specificationSelected.tierComputationSubType ==
                            2)) && (
                        <p className="ml-3 mt-3 ft-14 fw-200 grey">
                          Percentage/Basis Points
                          {specificationSelected?.formulaType == 1 ? (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Percentage"}
                            </p>
                          ) : (
                            <p className="mt-1 ft-14 fw-600 black">
                              {"Basis Points"}
                            </p>
                          )}
                        </p>
                      )}

                      {specificationSelected.allocationType == 2 && (
                        <>
                          {specificationSelected.formulaType == 1 ? (
                            <>
                              <p className="ml-3 mt-3 ft-14 fw-200 grey">
                                Fee Percentage{" "}
                              </p>
                              <p className="mt-1 ml-3 ft-14 fw-600 black">
                                {
                                  specificationSelected?.feePercentageOrBasisPoints
                                }{" "}
                                %
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="ml-3 mt-3 ft-14 fw-200 grey">
                                Fee Basis Points{" "}
                              </p>
                              <p className="mt-1 ml-3 ft-14 fw-600 black">
                                {
                                  specificationSelected?.feePercentageOrBasisPoints
                                }{" "}
                                BP
                              </p>
                            </>
                          )}
                        </>
                      )}

                      {specificationSelected?.allocationType == 3 && (
                        <TieredParticiantBalance
                          addSpecificationdata={specificationSelected}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <ValidationPopup
                  showModal={showValidationPopup}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
              </ManageFeeLayout>
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default CalculateContainer;
